
function ProjectsDatabase() {
    return [
        {
            "picture": "",
            "logo": "https://i.ibb.co/fFZPYyD/htmlcode.png",
            "name": "JustPC",
            "summary": "Build your dream PC with the best prices",
            "dates": "October 2020 - Present",
            "paragraphs": [
                "This is the side project I am currently working on in my free time.",
                "There is no such platform in Poland yet, and I want to make price comparision easier.",
                "As there is no public API's for any websites in Poland currently, a lot of work is done by scraping public data, which makes this way harder.",
            ],
            "technologies": [
                "NodeJS",
                "Python",
                "React",
            ],
            "color": "rgba(240, 105, 97, 1)",
            "textColor": "rgba(240, 105, 97, 1)",
            "git": "https://github.com/Kukiezi/justpc",
            "messeges": [
                "This project is quite a tough one to work on...",
                "it needs data from many sources and the sources often change!",
                "Not to mention collecting and making the fusion of the same products with different names.",
                "But I believe the final result will be worth it and useful!",
            ]
        }, 
        {
            "picture": "https://scontent-waw1-1.xx.fbcdn.net/v/t1.15752-9/74828478_2538468676439097_1975065243918794752_n.png?_nc_cat=100&ccb=1-3&_nc_sid=ae9488&_nc_ohc=pvSGC7p5u40AX_ICtBM&_nc_ht=scontent-waw1-1.xx&oh=33a23b77c7f552a7bce8979a426f66c6&oe=60D537C4",
            "logo": "https://i.ibb.co/fFZPYyD/htmlcode.png",
            "name": "Streambuddy",
            "summary": "Cross-platform stream browser",
            "dates": "November 2019 - July 2020",
            "paragraphs": [
                "Streambuddy is a cross-platform stream browser from services like Twitch, Mixer, Youtube.",
                "Created to make it easier for clients to find their favourite live streams between all different streaming websites.",
                "Worked with many different APIs to get streaming content from various platforms in one place.",
                "Was deployed on DigitalOcean under domain steambuddy.tv",
            ],
            "technologies": [
                "PHP",
                "Laravel",
                "Javascript",
                "React",
                "PostgresQL"
            ],
            "color": "rgba(25,118,210, 0.2)",
            "textColor": "#1976d2",
            "git": "https://github.com/Kukiezi/StreamBuddy",
            "messeges": [
                "This is the project I was very proud of!",
                "I truly think it was innovative and not seen before",
                "all at one place stream platform. I built it fast to MVP and deployed it...",
                "but the marketing was not in place and the website did not get much attention.",
                "Then mixer died and I closed it down due to server costs 😭",
                "But this is one of the better experiences I had with personal projects."
            ]
        },
        {
            "picture": "",
            "logo": "https://i.ibb.co/fFZPYyD/htmlcode.png",
            "name": "Messenger Pics Downloader",
            "summary": "Download pictures from your messenger chat",
            "dates": "April 2019",
            "paragraphs": [
                "Made this small program to allow downloading all pictures from provided Messenger Chat.",
                "Used Selenium for browser automatition.",
                "Multi-threaded for quicker image downloading.",
            ],
            "technologies": [
                "Python",
                "Selenium",
            ],
            "color": "rgba(25,118,210, 0.2)",
            "textColor": "#1976d2",
            "git": "https://github.com/Kukiezi/messenger-pics-downloader",
            "messeges": [
                "This project came to live as I personally needed the tool!",
                "I had a lot of images in my chat with girlfriend I needed and couldn't find a way...",
                "so I made the way myself and create this project!",
                "Not supported anymore as Facebook changes the website quite often...",
                "and I did not keep on maintaining the script.",
            ]
        }, 
        {
            "picture": "",
            "logo": "https://i.ibb.co/fFZPYyD/htmlcode.png",
            "name": "Personal Website",
            "summary": "The website you are looking at",
            "dates": "April 2021 - Present",
            "paragraphs": [
                "Created this website as an extra element for my portfolio.",
                "Learned about Material UI with React",
            ],
            "technologies": [
                "React",
                "Material UI",
            ],
            "color": "rgba(240, 105, 97, 1)",
            "textColor": "rgba(240, 105, 97, 1)",
            "git": "https://github.com/Kukiezi/personal-website",
            "messeges": [
                "Pretty cool website huh?",
                "I am far from great UI/UX designer...",
                "but I think this website is pretty neat!",
            ]
        }
    ]
}

export default ProjectsDatabase;
